/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {combineEpics, Epic} from 'redux-observable';
import applicationEpics from './epics/applicationEpics';
import pkReactNotificationsEpics from 'pk-react-notifications/dist/epics';
import notificationEpics from './epics/notificationEpics';
import accountEmailChangeEpics from './epics/accountEmailChangeEpics';
import accountRecoveryEpics from './epics/accountRecoveryEpics';
import flexServiceWorkerRegistrationEpics from './epics/flexServiceWorkerRegistrationEpics';
import confirmEmployeeRegistrationEpics from './epics/confirmEmployeeRegistrationEpics';
import loginEpics from './epics/loginEpics';
import resetPasswordEpics from './epics/resetPasswordEpics';

const rootEpic: Epic = combineEpics(
	accountEmailChangeEpics,
	accountRecoveryEpics,
	applicationEpics,
	confirmEmployeeRegistrationEpics,
	flexServiceWorkerRegistrationEpics,
	loginEpics,
	notificationEpics,
	resetPasswordEpics,
	pkReactNotificationsEpics
);

export default rootEpic;
